export default __webpack_public_path__ + "static/media/새마을금고.4e924b74.svg";